export default __webpack_public_path__ + "static/Design-Development-0fa3e4b30c96b022dbe366ef43259634.webp";